import backend from '@jg/i18next-dynamic-import-backend';
import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { format } from './lib/i18next';

i18n
  .use(initReactI18next)
  .use(
    backend(lang =>
      import(/* webpackChunkName: "lang/[request]" */ `../lang/${lang}.json5`)
    )
  )
  .use(LngDetector)
  .init({
    whitelist: ['en', 'en-GB', 'en-US', 'en-AU'],
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: {
      escapeValue: true,
      format,
    },
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'locale',
    },
  });
